(() => {
  'use strict';
  if (window.__vssKitsInstalled) return;
  window.__vssKitsInstalled = true;
  let busy = false;
  const shopRoot = () => window.Shopify?.routes?.root || '/';
  document.addEventListener('click', async (event) => {
    const button = event.target?.closest?.('[data-vss-kit-add]');
    if (!button || button.disabled || busy) return;
    event.preventDefault();
    const kitRoot = button.closest('[data-vss-kit-root]');
    if (!kitRoot) return;
    const status = kitRoot.querySelector('[data-vss-kit-status]');
    const label = button.querySelector('[data-vss-kit-label]');
    const originalLabel = label?.textContent || 'Add Complete Kit';
    const fail = (message) => { if (status) { status.textContent = message; status.dataset.error = 'true'; } };
    let items;
    try {
      const data = JSON.parse(kitRoot.querySelector('[data-vss-kit-data]').textContent);
      if (!data.valid || !data.available || !Array.isArray(data.items) || !data.items.length) throw new Error('This complete kit is currently unavailable.');
      const quantityInput = kitRoot.closest('product-info')?.querySelector('[data-vss-kit-quantity]');
      const multiplier = quantityInput ? Number(quantityInput.value) : 1;
      if (!Number.isSafeInteger(multiplier) || multiplier < 1) throw new Error('Enter a whole number of kits, starting at 1.');
      const aggregate = new Map();
      for (const item of data.items) {
        const id = Number(item.id);
        const quantity = Number(item.quantity) * multiplier;
        if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0) throw new Error('This complete kit is currently unavailable.');
        const sum = (aggregate.get(id) || 0) + quantity;
        if (!Number.isSafeInteger(sum)) throw new Error('The selected kit quantity is too large.');
        aggregate.set(id, sum);
      }
      items = [...aggregate].map(([id, quantity]) => ({id, quantity, properties: {'_VSS Kit': kitRoot.dataset.kitTitle || '', '_VSS Kit SKU': kitRoot.dataset.kitSku || ''}}));
    } catch (error) { fail(error.message || 'This complete kit is currently unavailable.'); return; }
    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding complete kit…';
    if (status) { status.textContent = ''; delete status.dataset.error; }
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    let sections = [];
    try { sections = cart?.getSectionsToRender?.().map(section => section.id).filter(Boolean).slice(0, 5) || []; } catch (_) {}
    const payload = {items};
    if (sections.length) { payload.sections = sections; payload.sections_url = window.location.pathname; }
    let added = false;
    try {
      cart?.setActiveElement?.(button);
      const response = await fetch(shopRoot() + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify(payload)});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'The complete kit could not be added. Please check availability and your basket before trying again.');
      added = true;
      if (status) status.textContent = 'Complete kit added to your basket.';
      document.dispatchEvent(new CustomEvent('vss:kit-added', {detail:{items, response:data}}));
      if (cart?.renderContents && sections.length && sections.every(id => data.sections?.[id])) {
        cart.classList.remove('is-empty');
        cart.renderContents({...data, id:data.id || data.items?.[0]?.id || items[0].id});
      } else {
        window.location.assign(shopRoot() + 'cart');
      }
    } catch (error) {
      if (added) window.location.assign(shopRoot() + 'cart');
      else fail(error.message || 'The complete kit could not be added. Please check your basket before trying again.');
    } finally {
      busy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (label) label.textContent = originalLabel;
    }
  });
})();
